import React from "react";
import PropTypes from "prop-types";
import CardLongContentCategory from "./CardLongContentCategory";
import CardPublishContent from "../../component-library/CardMeta/CardPublishContent";

const CardLongFooter = ({ children = null, className = "" }) => {
  return <div className={`card__footer ${className}`}>{children}</div>;
};

CardLongFooter.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};

export default Object.assign(CardLongFooter, {
  ContentCategory: CardLongContentCategory,
  PublishContent: CardPublishContent
});
